import TrustpilotSliderMobile from './TrustpilotSliderMobile'

export default TrustpilotSliderMobile
